(() => {
  const key = 'dut-favourites-v1';
  const dialog = document.getElementById('dut-favourites');
  const status = document.getElementById('dut-favourites-status');
  let items = [];
  function read() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(data) ? data.filter(x => x && typeof x.id === 'string' && typeof x.title === 'string' && typeof x.url === 'string' && x.url.startsWith('/products/')).slice(0, 100) : [];
    } catch { items = []; }
  }
  function sync() {
    document.querySelectorAll('[data-favourite-id]').forEach(button => {
      const saved = items.some(x => x.id === button.dataset.favouriteId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + button.dataset.title + (saved ? ' from' : ' to') + ' favourites');
    });
    document.querySelectorAll('.dut-favourites-count').forEach(count => {
      if (count.textContent !== String(items.length)) count.textContent = items.length;
      count.hidden = !items.length;
    });
  }
  function save() {
    try { localStorage.setItem(key, JSON.stringify(items)); status.textContent = 'Favourites updated.'; }
    catch { status.textContent = 'Your browser could not save favourites for next time.'; }
    sync();
  }
  function render() {
    const list = dialog.querySelector('.dut-favourites-list');
    list.replaceChildren();
    dialog.querySelector('[data-saved-total]').textContent = items.length + (items.length === 1 ? ' saved favourite' : ' saved favourites');
    if (!items.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Found something you love? Tap its heart to save it here.';
      list.append(empty);
    }
    for (const item of items) {
      const row = document.createElement('div');
      row.className = 'dut-saved-item';
      const link = document.createElement('a');
      link.href = item.url;
      if (typeof item.image === 'string' && (item.image.startsWith('https://') || item.image.startsWith('http://') || item.image.startsWith('/'))) {
        const image = document.createElement('img');
        image.src = item.image; image.alt = ''; image.loading = 'lazy';
        link.append(image);
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      const details = document.createElement('span');
      details.className = 'dut-saved-details';
      const action = document.createElement('span');
      action.className = 'dut-saved-view';
      action.textContent = 'View product →';
      details.append(title, action); link.append(details);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + item.title + ' from favourites');
      remove.onclick = () => {
        const index = items.findIndex(x => x.id === item.id);
        items = items.filter(x => x.id !== item.id); save(); render();
        const buttons = dialog.querySelectorAll('.dut-saved-item button');
        (buttons[Math.min(index, buttons.length - 1)] || dialog.querySelector('[data-favourites-close]')).focus();
      };
      row.append(link, remove); list.append(row);
    }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('.dut-menu-saved')) {
      const drawer = event.target.closest('header-drawer');
      drawer?.closeMenuDrawer(event);
      setTimeout(() => document.querySelector('.dut-favourites-open')?.click(), 350);
    }
    const heart = event.target.closest('[data-favourite-id]');
    if (heart) {
      const id = heart.dataset.favouriteId;
      if (items.some(x => x.id === id)) items = items.filter(x => x.id !== id);
      else if (items.length < 100) items.push({ id, title: heart.dataset.title, url: heart.dataset.url, image: heart.dataset.image });
      else { status.textContent = 'Your favourites are full. Remove an item to save another.'; return; }
      save();
    }
    if (event.target.closest('.dut-favourites-open')) { render(); dialog.showModal(); }
    if (event.target.closest('[data-favourites-close]') || event.target === dialog) dialog.close();
  });
  window.addEventListener('storage', event => { if (event.key === key) { read(); sync(); if (dialog.open) render(); } });
  let queued = false;
  new MutationObserver(records => {
    // Only new favourite controls need synchronising after AJAX rendering.
    const hasNewControls = records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-favourite-id]') || node.querySelector('[data-favourite-id]'))
    ));
    if (queued || !hasNewControls) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  read(); sync();
})();
